import Vue from "vue";
import VueI18n from "vue-i18n";

Vue.use(VueI18n);

function loadLocaleMessages() {
  const messages = {};
  const brandId = sessionStorage.getItem("bp:brand");
  const modules = ['article'];


  // โหลด base language (en, th)
  const baseLocales = require.context("./locales", true, /\.yaml$/);
  baseLocales.keys().forEach((key) => {
    const locale = key.match(/\.\/(.*)\.yaml$/)[1];
    messages[locale] = baseLocales(key);
  });

  // brand config text label
  let brandContent = {};
  if (brandId) {
    try {

      const allBrandModules = require.context("./", true, /\.yaml$/);
      modules.forEach((module) => {
        let key = `./${brandId}/${module}.yaml`;
        if (allBrandModules.keys().includes(key)) {
          brandContent = allBrandModules(key);
        }else{
          // default
          key = `./common/${module}.yaml`;
          brandContent = allBrandModules(key);
        }
      });
    } catch (e) {
      console.warn(`Brand '${brandId}' has no custom i18n overrides.`);
    }
  }

  for (const locale of Object.keys(messages)) {
    messages[locale] = {
      ...messages[locale],
      ...(brandContent || {}),
    };
  }
  return messages;
}

export default new VueI18n({
  locale: "en",
  fallbackLocale: "en",
  messages: loadLocaleMessages(),
});
